import React from "react";
import Reveal from "../components/Reveal";
import { SCENES } from "../renders";
import { useSteffiCopy } from "../content";

/* The quiet payoff between "she motivates" and "built for the family":
   what all of it actually looks like at the kitchen table. */
export default function LivingBand() {
  const { LIVING } = useSteffiCopy();

  return (
    <section className="relative overflow-hidden bg-[color:var(--bg)]">
      <Reveal>
        <figure className="relative">
          <img
            src={SCENES.living.src}
            width={SCENES.living.w}
            height={SCENES.living.h}
            alt={LIVING.alt}
            loading="lazy"
            decoding="async"
            className="block h-[62vh] max-h-[42rem] min-h-[22rem] w-full object-cover"
            style={{ objectPosition: "center 80%" }}
          />
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0"
            style={{
              background:
                "linear-gradient(90deg, color-mix(in srgb, var(--bg) 92%, transparent) 0%, color-mix(in srgb, var(--bg) 55%, transparent) 26%, transparent 52%)",
            }}
          />
          <figcaption className="absolute inset-y-0 left-0 flex w-full max-w-[34rem] items-center px-6 lg:px-16">
            <p className="t-feature !text-[clamp(1.5rem,2.6vw,2.25rem)] leading-[1.14]">
              {LIVING.lead}
              <span className="block text-[color:var(--ink-2)]">{LIVING.trail}</span>
            </p>
          </figcaption>
        </figure>
      </Reveal>
    </section>
  );
}
